/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";
import { IContent } from "@kunduz/data-access-cms-api";

const MobileLazyLoadedRight = dynamic<any>(
  () => {
    return import("./mobileRight").then((module) => module.MobileRight);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton style={{ width: 120, height: 34 }} />
      </div>
    ),
  },
);

export const MobileRightLoader = (props: {
  headerType: "student" | "teacher" | "school";
  mobileRightCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}): ReactElement => {
  return <MobileLazyLoadedRight {...props} />;
};
